// The tag vocabulary from the cross-product UI tagging guideline
// (roadmap/ui-tagging-guideline.md §3). It lives here until the shared
// areas.yaml has an owner (spec D9); keep the two in step when it does.

/** Lowercase levels joined by "-", at most five levels. "_" joins words inside a level. */
export const TAG_PATTERN = /^[a-z0-9_]+(-[a-z0-9_]+){0,4}$/;
export const TAG_MAX_LENGTH = 64;

export function isValidTag(tag: string): boolean {
  return tag.length <= TAG_MAX_LENGTH && TAG_PATTERN.test(tag);
}

/** Global UI chrome that sits outside any page area. */
export const SURFACES = ["sp", "top", "cmd"] as const;

/** Artie's page areas. Navigation elements use these as destination nouns. */
export const AREAS = [
  "chat",
  "projects",
  "skills",
  "knowledge",
  "meetings",
  "plugins",
  "schedules",
  "marketplace",
  "dashboard",
  "publisher",
  "organization",
  "embed_keys",
] as const;

/** Action verbs. Add one only by agreement across products (guideline §3.3). */
export const VERBS = [
  "open", "close", "create", "save", "submit", "cancel", "delete", "edit",
  "approve", "reject", "sign_off", "assign", "upload", "download", "export",
  "import", "search", "filter", "sort", "select", "toggle", "next", "back",
  "send", "print", "copy", "refresh", "expand", "collapse", "rename",
] as const;
